import type { ReactNode } from 'react'
import React from 'react'
import { formatQuantity } from '@ztechapps/common.utils'

export type QuantityWithUomProps = {
  quantity: number
  symbol: string
  decimalPrecision?: number
  className?: string
}

export const QuantityWithUom = ({ quantity, symbol, decimalPrecision = 0, className }: QuantityWithUomProps) => {
  return (
    <span className={className}>
      {formatQuantity(quantity, decimalPrecision)}
      <UomDisplay>{symbol}</UomDisplay>
    </span>
  )
}

export const UomDisplay = (props: { children: ReactNode }) => {
  return <code className="ms-0 fw-bold">{props?.children}</code>
}
